import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { langPath } from '../../utils/langPath';

/**
 * Drop-in remplacement de <Link> qui auto-préfixe les URLs internes avec /fr ou /en
 * selon la langue active. Voir utils/langPath pour les règles de préfixage.
 *
 * Usage : remplacer `import { Link } from 'react-router-dom'`
 * par    `import LangLink from '...'` et `<LangLink to="/about">`
 *
 * Tous les autres props de <Link> sont supportés (className, onClick, replace, etc.).
 */
export default function LangLink({ to, ...props }) {
    const { language } = useLanguage();
    return <Link to={langPath(to, language)} {...props} />;
}
